// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var TypeUtils = require("./TypeUtils.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var GraphQL_PPX = require("@reasonml-community/graphql-ppx/bucklescript/GraphQL_PPX.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var CommonTypes_QwickScoreType = require("./CommonTypes_QwickScoreType.bs.js");
var CommonTypes_Worker_ActiveId = require("./worker/CommonTypes_Worker_ActiveId.bs.js");
var CommonTypes_ShiftType_Category = require("./CommonTypes_ShiftType_Category.bs.js");
var CommonTypes_ShiftType_Accessories = require("./CommonTypes_ShiftType_Accessories.bs.js");

var include = TypeUtils.MakeOpaqueStringType({});

var decode = include.decode;

var encode = include.encode;

var compare = include.compare;

var eq = include.eq;

function parse(param) {
  return Relude_Globals.$great$great((function (param) {
                return Relude_Globals.$great$great(decode, Relude_Result.toOption, param);
              }), Relude_Option.getOrThrow, param);
}

var GraphQL_API = {
  parse: parse,
  serialize: encode
};

var Id_fromString = include.fromString;

var Id_toString = include.toString;

var Id_Ord = include.Ord;

var Id_Set = include.$$Set;

var Id_Map = include.$$Map;

var Id = {
  fromString: Id_fromString,
  toString: Id_toString,
  decode: decode,
  encode: encode,
  compare: compare,
  eq: eq,
  Ord: Id_Ord,
  $$Set: Id_Set,
  $$Map: Id_Map,
  GraphQL_API: GraphQL_API
};

var Raw = {};

var query = "fragment CommonTypes_ShiftType on ShiftType   {\ncategory  {\n...CommonTypes_ShiftType_Category   \n}\n\ndescription  \ndisplayOrder  \nid  \nminimumActiveId  \nname  \nqwickScoreType  \nrequiresAlcoholCert  \nrequiresFoodCert  \n...CommonTypes_ShiftType_Accessories   \n}\n" + CommonTypes_ShiftType_Accessories.query + CommonTypes_ShiftType_Category.query;

function parse$1(value) {
  var value$1 = value["category"];
  var value$2 = value["description"];
  var value$3 = value["qwickScoreType"];
  var tmp;
  if (value$3 == null) {
    tmp = undefined;
  } else {
    var tmp$1;
    switch (value$3) {
      case "BOH" :
          tmp$1 = "BOH";
          break;
      case "FOH" :
          tmp$1 = "FOH";
          break;
      default:
        tmp$1 = {
          NAME: "FutureAddedValue",
          VAL: value$3
        };
    }
    tmp = tmp$1;
  }
  var value$4 = value["requiresAlcoholCert"];
  var value$5 = value["requiresFoodCert"];
  return {
          category: CommonTypes_ShiftType_Category.verifyArgsAndParse("CommonTypes_ShiftType_Category", value$1),
          description: !(value$2 == null) ? value$2 : undefined,
          displayOrder: value["displayOrder"],
          id: parse(value["id"]),
          minimumActiveId: value["minimumActiveId"],
          name: value["name"],
          qwickScoreType: tmp,
          requiresAlcoholCert: !(value$4 == null) ? value$4 : undefined,
          requiresFoodCert: !(value$5 == null) ? value$5 : undefined,
          commonTypes_ShiftType_Accessories: CommonTypes_ShiftType_Accessories.verifyArgsAndParse("CommonTypes_ShiftType_Accessories", value)
        };
}

function serialize(value) {
  var value$1 = value.requiresFoodCert;
  var requiresFoodCert = value$1 !== undefined ? value$1 : null;
  var value$2 = value.requiresAlcoholCert;
  var requiresAlcoholCert = value$2 !== undefined ? value$2 : null;
  var value$3 = value.qwickScoreType;
  var qwickScoreType = value$3 !== undefined ? (
      typeof value$3 === "string" ? (
          value$3 === "FOH" ? "FOH" : "BOH"
        ) : value$3.VAL
    ) : null;
  var value$4 = value.name;
  var value$5 = value.minimumActiveId;
  var value$6 = value.id;
  var value$7 = Curry._1(encode, value$6);
  var value$8 = value.displayOrder;
  var value$9 = value.description;
  var description = value$9 !== undefined ? value$9 : null;
  var value$10 = value.category;
  var category = CommonTypes_ShiftType_Category.serialize(value$10);
  return [CommonTypes_ShiftType_Accessories.serialize(value.commonTypes_ShiftType_Accessories)].reduce(GraphQL_PPX.deepMerge, {
              category: category,
              description: description,
              displayOrder: value$8,
              id: value$7,
              minimumActiveId: value$5,
              name: value$4,
              qwickScoreType: qwickScoreType,
              requiresAlcoholCert: requiresAlcoholCert,
              requiresFoodCert: requiresFoodCert
            });
}

function verifyArgsAndParse(_CommonTypes_ShiftType, value) {
  return parse$1(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  return {
          accessories: CommonTypes_ShiftType_Accessories.tToR(param.commonTypes_ShiftType_Accessories),
          category: param.category,
          description: Relude_Option.getOrElse("", param.description),
          displayOrder: param.displayOrder,
          id: param.id,
          minimumActiveId: CommonTypes_Worker_ActiveId.toEnum(param.minimumActiveId),
          name: param.name,
          qwickScoreType: Relude_Option.map(CommonTypes_QwickScoreType.parseApiResponse, param.qwickScoreType),
          requiresAlcoholCert: Relude_Option.getOrElse(false, param.requiresAlcoholCert),
          requiresFoodCert: Relude_Option.getOrElse(false, param.requiresFoodCert)
        };
}

function toString(param) {
  return param.name;
}

function compare$1(param, param$1) {
  return Curry._2(compare, param.id, param$1.id);
}

var compareByName = Curry._1(Relude_String.compareWithConversion, (function (param) {
        return param.name;
      }));

function eq$1(param, param$1) {
  return Curry._2(eq, param.id, param$1.id);
}

var Ord = {
  compare: compare$1,
  eq: eq$1
};

var $$Set = Relude_Set.WithOrd({
      eq: eq$1,
      compare: compare$1
    });

var Accessories;

var Accessory;

var Category;

exports.Accessories = Accessories;
exports.Accessory = Accessory;
exports.Category = Category;
exports.Id = Id;
exports.Raw = Raw;
exports.query = query;
exports.parse = parse$1;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.toString = toString;
exports.compare = compare$1;
exports.compareByName = compareByName;
exports.eq = eq$1;
exports.Ord = Ord;
exports.$$Set = $$Set;
/* include Not a pure module */
